export const listStyles = {
  backdropFilter: 'blur(10px)',
  borderRadius: '8px',
  padding: '16px',
  minWidth: '400px',
};
